import React from "react";
import Dashboard from "../template/Dashboard";

export default () => {
  return <Dashboard />;
};
